import { render, staticRenderFns } from "./deliveryDetailTable.vue?vue&type=template&id=317fed01&scoped=true&"
import script from "./deliveryDetailTable.vue?vue&type=script&lang=js&"
export * from "./deliveryDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDetailTable.vue?vue&type=style&index=0&id=317fed01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317fed01",
  null
  
)

export default component.exports